import React, { useState } from 'react';
import { IoCloseCircleOutline, IoDownloadOutline, IoExpandOutline } from "react-icons/io5";

const PropertyImageModel = ({ selectedImage, isOpen, isClose }) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  if (!isOpen) return null;

  const handleDownload = async () => {
    try {
      const response = await fetch(selectedImage);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = selectedImage.split('/').pop() || 'image';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  const getFileName = (url) => {
    try {
      const urlObj = new URL(url);
      return decodeURIComponent(urlObj.pathname.split('/').pop()) || 'Image';
    } catch {
      return url.split('/').pop() || 'Image';
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 backdrop-blur-sm"
      onClick={isClose}
    >
      <div
        className="bg-white relative rounded-lg max-w-[95vw] max-h-[95vh] overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-3 bg-gray-50 border-b">
          <h3 className="text-sm font-medium text-gray-700 truncate flex-1 mr-4">
            {getFileName(selectedImage)}
          </h3>
          <div className="flex items-center gap-2">
            <button
              onClick={handleDownload}
              className="p-2 rounded-full bg-white shadow-sm hover:bg-gray-100 transition duration-200"
              title="Download Image"
            >
              <IoDownloadOutline className="text-gray-600 text-lg" />
            </button>
            <button
              onClick={() => setIsZoomed(!isZoomed)}
              className="p-2 rounded-full bg-white shadow-sm hover:bg-gray-100 transition duration-200"
              title={isZoomed ? "Zoom Out" : "Zoom In"}
            >
              <IoExpandOutline className="text-gray-600 text-lg" />
            </button>
            <button
              onClick={isClose}
              className="p-2 rounded-full bg-white shadow-sm hover:bg-red-50 transition duration-200"
              title="Close"
            >
              <IoCloseCircleOutline className="text-red-500 text-lg" />
            </button>
          </div>
        </div>

        {/* Image Container */}
        <div className="relative bg-gray-100 flex items-center justify-center" style={{ minHeight: '400px' }}>
          {!imageLoaded && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            </div>
          )}
          <img
            src={selectedImage}
            alt="Property Preview"
            className={`transition-all duration-300 ${
              isZoomed 
                ? 'max-w-none max-h-none cursor-zoom-out scale-150' 
                : 'max-w-[85vw] max-h-[70vh] cursor-zoom-in object-contain'
            } ${!imageLoaded ? 'opacity-0' : 'opacity-100'}`}
            onLoad={() => setImageLoaded(true)}
            onClick={() => setIsZoomed(!isZoomed)}
          />
        </div>

        {/* Footer */}
        <div className="p-3 bg-gray-50 border-t text-center">
          <p className="text-xs text-gray-500">
            Click image to {isZoomed ? 'zoom out' : 'zoom in'} • Right-click to save
          </p>
        </div>
      </div>
    </div>
  );
};

export default PropertyImageModel;
